import ContestModal from '@/components/modal/ContestModal.vue'
import LoginModal from '@/components/modal/LoginModal.vue'
import { useModalSlot } from 'vue-final-modal'
import { useCustomModal } from '~/modalHelper'

const onOpenLoginModal = async () => {
  contestModal.patchOptions(getLoginModalConfig())
}

const resetContestModal = () => {
  contestModal.patchOptions(getContestModalConfig())
}

const getContestModalConfig = () => ({
  attrs: {
    modalId: 'contest',
    title: 'Participer au concours',
    clickToClose: false,
    onClosed: resetContestModal,
  },
  slots: {
    default: useModalSlot({
      component: ContestModal,
    }),
    attrs: {
      onOpenLoginModal,
    },
  },
})

export const contestModal = useCustomModal(getContestModalConfig())

const getLoginModalConfig = () => ({
  attrs: {
    modalId: 'login',
    title: 'Connexion',
    clickToClose: false,
    onClosed: resetContestModal,
  },
  slots: {
    default: useModalSlot({
      component: LoginModal,
    }),
  },
})
